module.exports = __webpack_public_path__ + "img/img8.df314436.png";